import React from 'react';
import { handleZoom } from '../shared-canvas';
import { zoomInIcon, zoomOutIcon } from '../../../../assets/images/canvas';

/** Dashboard zoom UI — preserves legacy display offset (+20%) while using shared handleZoom. */
const CanvasZoom = ({ userZoomPercent, scaleToFit, setUserZoomPercent, setScale }) => (
  <div className="canvas-zoom">
    <img
      src={zoomOutIcon}
      alt="Zoom Out"
      onClick={() => handleZoom('out', { scaleToFit, setUserZoomPercent, setScale })}
    />
    {userZoomPercent + 20}%
    <img
      src={zoomInIcon}
      alt="Zoom In"
      onClick={() => handleZoom('in', { scaleToFit, setUserZoomPercent, setScale })}
    />
  </div>
);

export default CanvasZoom;
